import React from "react";

const Form = () => {

  return (
    <div className="search-form">
      <form action=""  className="search-form">
        <button className="search-btn"><i class="ri-search-line"></i></button>
        <input type="text" name="" id="" placeholder="search for anything " />
      </form>
    </div>
  );
  
};

export default Form;
